var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "menu-and-image d-lg-flex justify-content-lg-center align-items-lg-center mx-lg-auto px-lg-7 px-xl-0",
      class: {
        "flex-lg-row-reverse menu-and-image--right-menu":
          _vm.positionOfMenu == "right",
        "menu-and-image--center-image": _vm.centreAlignImage,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "menu-and-image__menu",
          class: {
            "justify-content-end":
              _vm.positionOfMenu == "right" && !_vm.centreAlignImage,
            "justify-content-center": _vm.centreAlignImage,
          },
        },
        [
          _c("div", [
            _c("h2", { staticClass: "h4 text-center text-lg-left mb-6" }, [
              _vm._v(_vm._s(_vm.titleText)),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "d-none d-lg-block" },
              _vm._l(_vm.contentJson, function (item, index) {
                return _c("li", { key: item.id }, [
                  _c(
                    "a",
                    {
                      class: { active: index == _vm.activeSlide },
                      attrs: { href: item.url },
                      on: {
                        mouseover: function ($event) {
                          return _vm.moveToSlide(index)
                        },
                        mouseout: function ($event) {
                          return _vm.moveToSlide(index)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.heading_text) +
                          "\n          "
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "menu-and-image__slider" },
        [
          _c(
            "slick",
            { ref: "main", attrs: { options: _vm.mainSlickOptions } },
            _vm._l(_vm.contentJson, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "slick-item-wrapper" },
                [
                  !item.use_video || !item.video_show_controls
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "image-link position-relative d-block image-link--hover-effect",
                          style: { backgroundColor: _vm.slideBackgroundColour },
                          attrs: { href: item.url },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "heading text-center d-none mb-4" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.heading_text) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          !item.use_video && item.image
                            ? _c("img", {
                                class: {
                                  "d-none d-lg-block": item.mobile_image,
                                },
                                attrs: {
                                  "data-lazy": item.image,
                                  alt: item.heading_text,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.mobile_image ||
                          (item.use_video && !item.use_video_mobile)
                            ? _c("img", {
                                staticClass: "d-lg-none",
                                attrs: {
                                  "data-lazy": item.mobile_image,
                                  alt: item.heading_text,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item.use_video && item.video_id
                            ? _c(
                                "div",
                                {
                                  class: [
                                    {
                                      "d-none d-lg-block":
                                        item.use_video_mobile &&
                                        item.video_id_mobile,
                                    },
                                    item.video_aspect_ratio,
                                  ],
                                },
                                [
                                  _c("iframe", {
                                    attrs: {
                                      src: item.video_id,
                                      frameborder: "0",
                                      allow: "autoplay; fullscreen",
                                      allowfullscreen: "",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.use_video &&
                          item.use_video_mobile &&
                          item.video_id_mobile
                            ? _c(
                                "div",
                                {
                                  staticClass: "d-block d-lg-none",
                                  class: item.video_aspect_ratio,
                                },
                                [
                                  _c("iframe", {
                                    attrs: {
                                      src: item.video_id_mobile,
                                      frameborder: "0",
                                      allow: "autoplay; fullscreen",
                                      allowfullscreen: "",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hideSliderTitles
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "images--headline position-absolute text-uppercase text-center",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.heading_text) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : [
                        item.use_video && item.video_id
                          ? _c("div", { class: item.video_aspect_ratio }, [
                              _c("iframe", {
                                attrs: {
                                  src: item.video_id,
                                  frameborder: "0",
                                  allow: "autoplay; fullscreen",
                                  allowfullscreen: "",
                                },
                              }),
                            ])
                          : _vm._e(),
                      ],
                ],
                2
              )
            }),
            0
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }